import { apiClient } from './client';

export interface FleetMetrics {
  total_agents: number;
  enabled_agents: number;
  disabled_agents: number;
  shops_with_agents: number;
  runs: number;
  failed_runs: number;
  tokens: number;
  pending_actions: number;
  executed_actions: number;
  approved_actions: number;
  rejected_actions: number;
  approval_rate: number | null;
}

export interface FleetMetricsParams {
  from: string;
  to: string;
}

export interface FleetRosterRow {
  id: string;
  shop_id: number;
  shop_name: string | null;
  shop_domain: string | null;
  persona_slug: string;
  enabled: boolean;
  mode: string;
  last_run_at: string | null;
  created_at: string | null;
}

export interface BulkCreateSummary {
  created: number[];
  skipped: number[];
  invalid: number[];
  created_count: number;
  skipped_count: number;
  invalid_count: number;
}

export interface FleetRosterEnvelope {
  data: FleetRosterRow[];
  meta: {
    total: number;
    current_page?: number;
    per_page?: number;
    last_page?: number;
  };
}

export interface FleetRosterParams {
  page?: number;
  per_page?: number;
  sort_field?: string;
  sort_order?: 'asc' | 'desc';
  search?: string;
  mode?: string;
}

export function getFleetMetrics (params: FleetMetricsParams) {
  return apiClient.get<{ data: FleetMetrics }>('/background-agents/fleet/metrics', { params });
}

export function getRoster (params: FleetRosterParams = {}) {
  return apiClient.get<FleetRosterEnvelope>('/background-agents/fleet/configurations', { params });
}

export function bulkCreateConfigurations (
  shopIds: number[],
  options?: { signal?: AbortSignal },
) {
  return apiClient.post<{ data: BulkCreateSummary }>(
    '/background-agents/fleet/configurations',
    { shop_ids: shopIds },
    { signal: options?.signal },
  );
}
